'use client';

import { type ReactNode, type RefObject, createContext, use, useRef } from 'react';

const TopDrawerProviderContext = createContext<RefObject<HTMLInputElement | null>>(null as unknown as RefObject<HTMLInputElement | null>);

interface TopDrawerProviderProps {
    children: ReactNode;
}

export function TopDrawerProvider({ children }: TopDrawerProviderProps) {
    const inputRef = useRef<HTMLInputElement>(null);

    return <TopDrawerProviderContext.Provider value={inputRef}>{children}</TopDrawerProviderContext.Provider>;
}

export function useTopDrawerProvider() {
    const context = use(TopDrawerProviderContext);
    if (!context) {
        throw new Error('useTopDrawerProvider must be used within a TopDrawerProvider');
    }

    return context;
}
